import nft from '@/api/nft'

// initial state
const state = {
    tokenList: [],
    item: {
        name: '',
        description: '',
        category: '',
        tradingAccount: '',
        fileId: '',
        hash: '',
        imageURI: ''
    },
    btnList: {},
    offerslist: {},
    categories: [],
    currencyList: [],
    sortByList: [],
    accountList: [],
}

// getters
const getters = {}

// actions
const actions = {
    getTokenList({ commit }, request) {
        nft.getTokenList(data => {
            commit('setTokenList', data.list)
        }, request)
    },
    getTokenListByOwner({ commit }) {
        nft.getTokenListByOwner(data => {
            commit('setTokenList', data.list)
        })
    },
    getTokenById({ commit }, id) {
        nft.getTokenById(result => {
            commit('setToken', result)
                // nft.getNFTasset(response => {
                //     commit('setOffers', response);
                // }, { "tokenId": id })
            nft.changebutton(responses => {
                commit('setButton', responses);
            }, { "id": id })
        }, id)
    },
    clearToken({ commit }) {
        commit('setToken', {
            name: '',
            description: '',
            category: '',
            tradingAccount: '',
            fileId: '',
            hash: '',
            imageURI: ''
        })
    },
    getCategories({ commit }) {
        nft.getCategories(response => {
            commit('setCategories', response.list);
        })
    },
    getCurrencyList({ commit }) {
        nft.getCurrencyLists(response => {
            commit('setCurrencyList', response.list)
        })
    },
    getSortByList({ commit }) {
        nft.getSortByList(response => {
            commit('setSortByList', response.list);
        })
    },
    saveToken({ commit }, request) {
        nft.saveToken(response => {
            // request.callback(response.id > -1 ? true : false)
            request.callback(response.id)
        }, request)
    },
    saveListing({ commit }, request) {
        nft.saveListing(response => {
            request.callback(response)
        }, request)
    },
    saveHighestbid({ commit }, request) {
        nft.saveHighestbid(response => {
            request.callback(response)
        }, request)
    },
    changesell({ commit }, request) {
        nft.changesell(response => {
            nft.changebutton(responses => {
                // location.reload()
                commit('setButton', responses);

            }, { "id": request.tokenId })
        }, request)
    },
    getNFTasset({ commit }, request) {
        nft.getNFTasset(response => {

            // request.callback(response)
        }, request)
    },
    postMakeoffer({ commit }, request) {
        nft.postMakeoffer(response => {
            request.callback(response)
        }, request)
    },
    buyNow({ commit }, request) {
        nft.buyNow(response => {
            request.callback(response)
        }, request)
    },
    changebutton({ commit }, request) {
        nft.changebutton(response => {
            commit('setButton', response);
        }, request)
    },
    changeCancel({ commit }, request) {
        nft.changeCancel(response => {
            request.callback(response)

        }, request)
    },
    changeAccept({ commit }, request) {
        nft.changeAccept(response => {
            request.callback(response)
        }, request)
    },
    getAccountList({ commit }) {
        nft.getAccountList(response => {
            commit('setAccountList', response.accountList)
        })
    },
}

// mutations
const mutations = {
    setTokenList(state, tokenList) {
        state.tokenList = tokenList
    },
    setAccountList(state, list) {
        state.accountList = list
    },
    setToken(state, token) {
        state.item = token
    },
    setCategories(state, categories) {
        state.categories = categories
    },
    setCurrencyList(state, currencyList) {
        state.currencyList = currencyList;
    },
    setSortByList(state, sortByList) {
        state.sortByList = sortByList
    },
    setButton(state, response) {
        state.btnList = response
    },
    setOffers(state, response) {
        state.offerslist = response
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}